import { defineComponent as _defineComponent } from 'vue'
import ServicoService from '@/services/ServicoService';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { Servico } from 'common/types/Servico';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogExcluirServico',
  props: {
    servico: null
  },
  setup(__props: any) {



const client = useQueryClient()

const mostra = ref(false)

const { mutate, isPending: excluindo } = useMutation({
	mutationFn: (id: string) => ServicoService.remove(id),
	onSuccess(_data, id) {
		mostra.value = false
        client.invalidateQueries({ queryKey: ['servicos'], exact: false })
	},
})

return { __sfc: true,client, mostra, mutate, excluindo }
}

})